import ColorSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/ColorSetting';
import FontFamily from 'hb-builder/components/common/SettingsLibrary/CommonSettings/FontFamily';
import { useBuilderConfigContext } from 'hb-builder/hooks';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';

const Headline = ({
  item,
  onChange,
}: Omit<ComponentSettingsTab, 'defaultAttributes'>) => {
  const settingProps = { onChange };
  const {
    features: { color },
    hivebrite: { networkColors, networkTheming },
  } = useBuilderConfigContext();
  const colorSettingsProps = {
    color,
    networkColors,
    networkTheming,
  };

  return (
    <>
      <FontFamily settingKey="textFontFamily" item={item} {...settingProps} />
      <ColorSetting
        settingKey="textColor"
        title={__('Text color')}
        item={item}
        transparent={false}
        {...settingProps}
        {...colorSettingsProps}
      />
      <ColorSetting
        settingKey="textBackgroundColor"
        title={__('Background text color')}
        item={item}
        transparent
        {...settingProps}
        {...colorSettingsProps}
      />
    </>
  );
};

export default Headline;
